import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api, { executeAction } from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import notifications from '../../../../redux/notifications/actions';
import { logger } from '../../../../helpers/logger';
import { t } from '../../../../i18n';
import { tableConfig } from '../../../../settings';

const api = new Api('workers/:id/infractions');
const formDataApi = new Api('worker_infractions/exceptions/form_data');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { id, search: { ...payload, page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(actions.loadDataSuccess({ records, filters, totalCount, filteredCount, sortableColumns }));
    }
  } catch (error) {
    console.warn(error);
  }
}

function* loadFormData() {
  try {
    const result = yield call(sendRequest, formDataApi.load, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess(result.data.success.data));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* submitException({ payload }) {
  try {
    const { id, data, talentId, url, method } = payload;

    const result = yield call(
      sendRequest,
      executeAction,
      {
        url,
        method,
        id,
        data,
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.talent.add_exception_success_message'),
        }),
      );

      yield put(actions.addExceptionSuccess());
      yield put(actions.loadData({ id: talentId }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* submitAction({ payload }) {
  try {
    const { data, url, method, key, talentId } = payload;

    const result = yield call(
      sendRequest,
      executeAction,
      {
        url,
        method,
        data,
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`dash.talent.warning_and_suspensions.notifications.${key}_action_success`),
        }),
      );
      yield put(actions.loadData({ id: talentId }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_REQUEST, loadData),
    takeEvery(actions.LOAD_FORM_DATA_REQUEST, loadFormData),
    takeEvery(actions.ADD_EXCEPTION_REQUEST, submitException),
    takeEvery(actions.SUBMIT_ACTION_REQUEST, submitAction),
  ]);
}
